<template>
  <img
    style="height: 100px"
    v-if="this.params !== undefined"
    :src="this.params.value"
    alt="img"
  />
</template>

<script>
export default {
  name: "SimpleButtonGroup",
  components: {},
  props: {
  },
  mounted() {
    console.log();
  },
  data: () => ({

  }),
  methods: {},
};
</script>
